import React from 'react';
/**
 * A generic form layout for general form items. Useful for the standard Texkit form layout.
 * Each direct child will be treated as a form group item.
 */

export function TxFormGroup(_ref) {
  var children = _ref.children,
      label = _ref.label;
  return React.createElement("div", {
    className: "tx-form-group"
  }, label && React.createElement("div", {
    className: "tx-form-group__label"
  }, label), React.createElement("div", {
    className: "tx-form-group__content"
  }, children));
}
export function TxFormActions(_ref2) {
  var children = _ref2.children;
  return React.createElement("div", {
    className: "tx-form-actions"
  }, React.createElement("div", {
    className: "tx-form-actions__content"
  }, children));
}